module.exports = __webpack_public_path__ + "static/botbot@2x-b48642ef74789ba6f9aad4565a49ee2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/developers/botbot@2x.png
// module id = 2552
// module chunks = 168707334958949